import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, pipe, timeout } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SearchCepService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getCep(cep: string): Observable<any> {
    return this.httpClient.get('https://brasilapi.com.br/api/cep/v1/'+cep, {headers: {'Content-Type': 'application/json'}}).pipe(
      timeout({
        each: 3000,
      }))
  }

  public getCep2(cep: string): Observable<any> {
    return this.httpClient.get<any>('https://viacep.com.br/ws/'+cep+'/json', {headers: {'x-skip-interceptor': 'x-skip-interceptor'}});
  }

}
